<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [Checkbox]
 * Чекбокс
 */

// ComponentsModalComponent

// Icon
import CheckIcon from "@/ui/icons/check.vue";

const emit = defineEmits<{
    (e: "update:modelValue", value: boolean): void;
}>();

function handleChange(event: Event) {
    const target = event.target as HTMLInputElement;
    emit("update:modelValue", target.checked);
}
</script>

<template>
    <label class="tiw__checkbox">
        <input
            type="checkbox"
            name="personal"
            class="tiw__checkbox__input"
            hidden
            v-bind="$attrs"
            @change="handleChange"
        />
        <div class="tiw__checkbox__mark">
            <CheckIcon variant="basic" />
        </div>
        <div class="tiw__checkbox__text">
            <slot />
        </div>
    </label>
</template>

<style lang="scss" src="./checkbox.scss"></style>
